/**
 * Created by Jie Gao on 2018-11-14.
 */
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {IReelStopSpinData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {SpinReelController} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelController";
import {SpinReelEvent} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelEvent";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {TweenLite} from "gsap";
import {StarStruckParsedGameData} from "../server/data/StarStruckParsedGameData";

export class StarStruckReelController extends SpinReelController {

    private _spinStartedTime:number;
    private _bonusFeatureTriggered:boolean = false;
    private _gameDataParsed:boolean = false;
    private _spinStarted:boolean = false;

    constructor(reelId:number) {
        super(reelId);
        this._nearWinReels = [false, false, false];
    }

    public onGameDataParsed(data:StarStruckParsedGameData):void {
        super.onGameDataParsed(data);
        this._bonusFeatureTriggered = data.bonusFeatureTriggered;
        if(this._bonusFeatureTriggered) {
            this._nearWinReels[1] = true;
        }
        this._gameDataParsed = true;
        this.tryStartNearWin();
    }

    protected onSpinStartedCompleted():void {
        super.onSpinStartedCompleted();
        this._spinStartedTime = Date.now();
        this._spinStarted = true;
        this.tryStartNearWin();
    }

    private tryStartNearWin() {
        if(this.reelId != 0 || !this._spinStarted || !this._gameDataParsed) {
            return;
        }
        if(this._nearWinReels[0]) {
            Logger.logDev(`reel0 starts near win!`);
            EventHandler.dispatchEvent(new GameEvent(SpinReelEvent.REEL_TRY_NEAR_WIN, 0));
        }
    }

    public stopSpin(data:IReelStopSpinData, delay:number):number {
        if(this._nearWinReels[0] && this.reelId === 0) {
            const timePassed:number = (Date.now() - this._spinStartedTime) / 1000;
            delay = Math.max(0, delay - timePassed);
            if(data.quickStop) {
                const spinSpeed = GameConfig.instance.REEL_SPIN_QUICK_STOP_SPEED;
                TweenLite.to(this._reelPartAnimator, 0, {spinSpeed : spinSpeed});
            }
        }
        this.resetNearWinState();
        return super.stopSpin(data, delay);
    }

    private resetNearWinState():void {
        this._spinStarted = false;
        this._gameDataParsed = false;
    }
}